// extracted by mini-css-extract-plugin
export default {"container":"CvFileUploader-module__container__hVrsE"};